import { useRef, } from "react";
import { Canvas, useThree, useFrame } from "@react-three/fiber";
import {
  Text,
  PerspectiveCamera,
  OrbitControls,
} from "@react-three/drei";
import allColors from './Colors'
import * as Tone from 'tone'
let randI = (i) => Math.floor(i * fxrand())
let rand = (arr) => arr[randI(arr.length)]
let ci = randI(allColors.length)
let colors = allColors[ci]
let bg = colors.shift()
let accent = rand(colors)
let patternLength = rand([12,16,20,24,28,32])
let textSize = rand([0.5,0.75,1])
let octaves = rand([
  [2,3],
  [5,6,7]
])
const feats = window.$fxhashFeatures = {
  ropeLength: patternLength,
  bg,
  scale: textSize,
  octaves: JSON.stringify(octaves)
}
console.table(feats)
let synth = new Array(patternLength).fill().map(() => {
  let am = new Tone.AMSynth({
    "harmonicity": 2,
    "oscillator": {
      "type": "amsine2",
      "modulationType": "sine",
      "harmonicity": 1.01
    },
    "envelope": {
      "attack": 0.006*textSize,
      "decay": 4,
      "sustain": 0.04,
      "release": 0.2
    },
    "modulation": {
      "volume": 13,
      "type": "amsine2",
      "modulationType": "sine",
      "harmonicity": 12
    },
    "modulationEnvelope": {
      "attack": 0.1*textSize,
      "decay": 0.2,
      "sustain": 0.2,
      "release": 0.4
    }
  }).connect(new Tone.PingPongDelay('8n',0.8).toDestination())
  am.connect(new Tone.Gain(1.2).toDestination())
  return am
})

let hihats =
  [
    './drums/HIHATS/Legowelt Hat6open.wav',
  ].map((v) => {
    let sampler = new Tone.Sampler({
      C3: v
    }).connect(new Tone.Gain(0.4).connect(new Tone.PingPongDelay('4t',0.89).connect(new Tone.Panner((-5 + randI(10)) * 0.05).toDestination())))
    sampler.attack = 0.1
    sampler.connect(new Tone.Gain(0.1).toDestination())
    return sampler
  })

Tone.context.lookAhead = 0.1
let loopCount = 0
let lastPlayed = false
let loop = new Tone.Loop(() => {
  currChars.unshift(rand(currChars))
  currChars.splice(patternLength, 1)
  if (fCount && !lastPlayed) {
    lastPlayed = true
    synth[loopCount % patternLength].triggerAttackRelease(notes[chars.indexOf(currChars[currChars.length - 1])], '4n', '+0.001', rand([0.1, 0.12, 0.15, 0.18]) * 0.2)
  }
  !fCount && synth[loopCount % patternLength].triggerAttackRelease(notes[chars.indexOf(currChars[currChars.length - 1])], '16n', '+0.001', rand([0.1, 0.12, 0.15, 0.18]) * 0.2)
  loopCount++;
}, '16n')
let started = false
export default function App() {
  const click = () => {
    if(!started){
      Tone.start();
      Tone.Transport.start()
      loop.start()
      started = true
      randVis(false)
    }else{
      randVis(true)
    }
  }
  return (
    <div id="main" onClick={() => click()} >
      <Canvas>
        <PerspectiveCamera position={[0, 0, 80]} fov={10} makeDefault />
          <Typography />
        <OrbitControls maxDistance={130} />
        <color attach="background" args={[bg]} />
      </Canvas>
    </div>
  );
}
let randVis = (doHat) => {
  fCount = 0
  Tone.Transport.bpm.value = getBpm()
  colDiv = 1 + randI(8)
  colMod = 1 + randI(3)
  lastPlayed = false
  if(doHat){
    hihats[0].triggerAttackRelease(['C2'], 8, '+0.0001', rand([0.1, 0.12, 0.15, 0.18]) * 0.6)
    hihats[0].triggerAttackRelease(['C2'], 8, '+0.0001', rand([0.1, 0.12, 0.15, 0.18]) * 0.6)
  }
  currChars = new Array(patternLength).fill().map(() => rand(chars))
  currChars = new Array(patternLength).fill().map(() => rand(chars))
  charMode = randI(getChars.length)
}

let getBpm = () => 50 + randI(350)
Tone.Transport.bpm.value = getBpm()
let chars = '-/\\=_:|..:-;"'
let currChars = new Array(patternLength).fill().map(() => rand(chars))
let notes = currChars.map(() => rand(['C', 'D', 'E', 'G']) + octaves)
let gridSize = 60/textSize
let fCount = 0
let rot = randI(4) * Math.PI * 0.5
let colDiv = 1 + randI(8)
let rowDiv = 1 + randI(8)
let colMod = 1 + randI(8)
let getChars = [
  (r,c) => ((Math.floor(((r *r* r) + (c * c)) / colDiv)) % colMod) ? currChars : [...currChars].reverse(),
  (r,c) => ((Math.floor(r / (colDiv*c))) % colMod) ? currChars : [...currChars].reverse(),
  (r,c) => ((Math.floor(r / (colDiv*c))) % colMod) ? currChars : [...currChars].reverse(),
  (r,c) => ((Math.ceil(c / colDiv)) % colMod) ? currChars : [...currChars].reverse(),
  (r,c) => ((Math.ceil(r / rowDiv)) % colMod) ? currChars : [...currChars].reverse(),
  (r,c) => ((Math.ceil((r+(c+(loopCount%colDiv)*2)) / (colDiv))) % colMod) ? currChars : [...currChars].reverse(),
  (r,c) => ((Math.ceil((r+(c+(loopCount%colDiv)*0.25)) / (rowDiv))) % colMod) ? currChars : [...currChars].reverse(),
]
let charMode = randI(getChars.length)
let push = 1
const Typography = () => {
  const text = useRef();
  const { width, height } = useThree((state) => state.viewport);
  const vw = (size) => (width * size) / 100;
  const vh = (size) => (height * size) / 100;
  useFrame(() => {
    let st = ``
    let found = ''
    for (var r = 0; r < gridSize * 0.5; r++) {
      for (var c = 0; c < Math.floor(gridSize / patternLength*0.9); c++) {
        let curr = getChars[charMode](r,c)
        curr.forEach((c) => {
          st += c
          if (!found.includes(c)) {
            found += c
          }
        })
      }
      st += '\n'
    }
    if (found.length === 1) {
      fCount++
    }
    if (fCount && (fCount % 250 === 0)) {
      randVis(true)
    }
    text.current.text = st
    text.current.size = textSize
    text.current.rotation.z = rot
  })
  return (
    <Text
      ref={text}
      lineHeight={0.8}
      font="./IBMPlexMono-Medium.ttf"
      fontSize={vh(textSize) * 2.5}
      position={[0, 0, 0]}
      letterSpacing={-0.15}
      color={accent}
    >
      .
    </Text>
  );
};